/**
 * API service for home visit requests
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';
const API_KEY = import.meta.env.VITE_API_KEY || 'QmFzZTY0U2VjcmV0S2V5MTIzNDU2Nzg5MDEyMzQ1';

export interface CreateHomeVisitRequestData {
  patientName: string;
  patientCode?: string;
  primaryPhone: string;
  secondaryPhone?: string;
  address: string;
  requestedDate: string; // ISO 8601 format
  branchId: number;
  notes?: string;
  prescriptionImage?: File;
}

export interface HomeVisitResponse {
  id: number;
  patientName: string;
  patientCode?: string;
  primaryPhone: string;
  secondaryPhone?: string;
  address: string;
  requestedDate: string;
  branchId: number;
  status: number;
  createdAt: string;
  updatedAt?: string;
  notes?: string;
  prescriptionImagePath?: string;
  history: Array<{
    id: number;
    oldStatus: number | null;
    newStatus: number;
    changedAt: string;
    notes?: string;
  }>;
}

/**
 * Creates a new home visit request
 */
export async function createHomeVisitRequest(
  data: CreateHomeVisitRequestData
): Promise<HomeVisitResponse> {
  const formData = new FormData();

  // Add all form fields
  formData.append('PatientName', data.patientName);
  if (data.patientCode) {
    formData.append('PatientCode', data.patientCode);
  }
  formData.append('PrimaryPhone', data.primaryPhone);
  if (data.secondaryPhone) {
    formData.append('SecondaryPhone', data.secondaryPhone);
  }
  formData.append('Address', data.address);
  formData.append('RequestedDate', data.requestedDate);
  formData.append('BranchId', data.branchId.toString());
  if (data.notes) {
    formData.append('Notes', data.notes);
  }

  // Add prescription image if provided
  if (data.prescriptionImage) {
    formData.append('PrescriptionImage', data.prescriptionImage);
  }

  const response = await fetch(`${API_BASE_URL}/api/home-visits`, {
    method: 'POST',
    headers: {
      'X-API-Key': API_KEY,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = 'Failed to create home visit request';
    
    try {
      const errorJson = JSON.parse(errorText);
      errorMessage = errorJson.detail || errorJson.message || errorMessage;
    } catch {
      errorMessage = errorText || errorMessage;
    }

    throw new Error(errorMessage);
  }

  return await response.json();
}

